import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, inject } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { getNoDataForBuildCacheCharts, useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import { useAgentsPageQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import buildCacheCpuRunTimeAndSavedTimeChart from './build-cache-cpu-run-time-and-saved-time-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'build-cache-cpu-run-time-and-saved-time-chart-controller',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);
const dashboardChartUtils = useDashboardChartUtils();
const dashboard = useDashboard();
const buildCacheCpuRunTimeAndSavedTimeChartConfig = dashboard.gridUtilization.buildCacheCpuRunTimeAndSavedTimeChart;
const GQL_AgentsPageQuery = useAgentsPageQuery(() => ({
  coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
}));
const options = computed(() => ({
  ...buildCacheCpuRunTimeAndSavedTimeChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: buildCacheCpuRunTimeAndSavedTimeChartConfig,
        chartId: buildCacheCpuRunTimeAndSavedTimeChartConfig.value.chartId,
        componentInstance: buildCacheCpuRunTimeAndSavedTimeChart,
      }),
    },
  },
}));

const noData = computed(() =>
  getNoDataForBuildCacheCharts(
    GQL_AgentsPageQuery?.result?.value?.ibManagerEntities?.licenseMetadata?.hasBuildCache || false,
    dashboard.metadata.value.gridUtilization.noData.buildCacheCpuRunTimeAndSavedTimeChart,
  ),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(buildCacheCpuRunTimeAndSavedTimeChart, {
    "no-data": _unref(noData),
    "chart-options": {
      ..._unref(buildCacheCpuRunTimeAndSavedTimeChartConfig),
      options: _unref(options),
    }
  }, null, 8, ["no-data", "chart-options"]))
}
}

})